import {
  IHotelSearchQueryArgs,
  IHotelSearchParams,
  IHotelsSearchSchema,
} from "@/feature/hotel/search/types/hotel-search-type";
import { format, isValid } from "date-fns";

export function formatDateV1(
  date?: Date | string,
  dateFormat = "yyyy-MM-dd",
): string {
  if (!date) return "";

  const parsedDate = typeof date === "string" ? new Date(date) : date;
  if (!isValid(parsedDate)) return "";

  return format(parsedDate, dateFormat);
}

export function encodedHotelParams(data: IHotelsSearchSchema): string {
  const { date, location, rooms } = data;

  const check_in = formatDateV1(date.from);
  const check_out = formatDateV1(date.to);
  const encodedRooms = encodeURIComponent(JSON.stringify(rooms));
  const encodedLocation = encodeURIComponent(JSON.stringify(location));

  return `check_in=${check_in}&check_out=${check_out}&rooms=${encodedRooms}&location=${encodedLocation}`;
}

export function decodedHotelParams(params: IHotelSearchParams): IHotelsSearchSchema {
  const { check_in, check_out, location, rooms } = params;

  return {
    date: {
      from: new Date(check_in),
      to: new Date(check_out),
    },
    rooms: JSON.parse(decodeURIComponent(rooms)),
    location: JSON.parse(decodeURIComponent(location)),
  };
}

export function toHotelSearchQueryArgs(
  data: IHotelsSearchSchema,
): IHotelSearchQueryArgs {
  return {
    date: {
      from: formatDateV1(data.date.from),
      to: formatDateV1(data.date.to),
    },
    location: {
      ...data.location,
    },
    rooms: data.rooms.map((room) => ({
      adults: room.adults,
      children: room.children,
      infants: room.infants,
      children_ages: room.children_ages ?? [],
    })),
  };
}
